import {getWebPushPublicKey, saveWebPushSubscription} from '../api';

export function isWebPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeBrowserToWebPush(token) {
  if (!isWebPushSupported()) {
    return {ok: false, reason: 'unsupported'};
  }
  const keyResponse = await getWebPushPublicKey(token);
  if (keyResponse.status !== 200 || !keyResponse.json.enabled || !keyResponse.json.publicKey) {
    return {ok: false, reason: 'not_configured'};
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    return {ok: false, reason: 'denied'};
  }
  const registration = await navigator.serviceWorker.register('/service-worker.js');
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(keyResponse.json.publicKey)
  });
  const response = await saveWebPushSubscription(subscription.toJSON(), token);
  if (response.status !== 201) {
    return {ok: false, reason: 'save_failed'};
  }
  return {ok: true, subscription: response.json.subscription};
}
